import { commonApi } from '@common/utils/baseQuery';
import {
  Quiz,
  QuizAnswers,
  QuizAttempt,
  QuizClaimResult,
  QuizStartResponse,
  QuizViewer,
} from '@features/quiz/api/quizApi.type';

export const quizApi = commonApi.injectEndpoints({
  endpoints: (build) => ({
    fetchActiveQuizzes: build.query<Quiz[], QuizViewer & { country: number }>({
      query: ({ country }) => ({
        url: '/quiz/active',
        params: { country },
      }),
      transformResponse: (response: unknown) => (Array.isArray(response) ? response as Quiz[] : []),
    }),
    fetchQuiz: build.query<Quiz, QuizViewer & { id: number }>({
      query: ({ id }) => `/quiz/${id}`,
    }),
    startQuiz: build.mutation<QuizStartResponse, { id: number, deviceKey: string }>({
      query: ({ id, deviceKey }) => ({
        url: `/quiz/${id}/start`,
        method: 'POST',
        body: { deviceKey },
      }),
    }),
    finishQuiz: build.mutation<QuizAttempt, { token: string, deviceKey: string, answers: QuizAnswers }>({
      query: ({ token, deviceKey, answers }) => ({
        url: `/quiz/attempt/${token}/finish`,
        method: 'POST',
        body: { deviceKey, answers },
      }),
    }),
    claimQuiz: build.mutation<QuizClaimResult, string>({
      query: (token) => ({
        url: '/quiz/claim',
        method: 'POST',
        body: { token },
      }),
    }),
  }),
});

export const {
  useFetchActiveQuizzesQuery,
  useFetchQuizQuery,
  useStartQuizMutation,
  useFinishQuizMutation,
  useClaimQuizMutation,
} = quizApi;
